module.exports = __webpack_public_path__ + "fbbc3b51d3fc48d829148b831affb8f3.svg";